<template>
  <b-form-select class="form-select"
                 :options="ratingOptions"
                 text-field="text"
                 value-field="value"
                 v-model="ratingOption"
                 @change="handleRatingOption"
  />
</template>

<script>
export default {
  name: "RatingFilter",
  data() {
    return {
      ratingOptions: [
        {
          text: this.$t('components.review.rating_filter.options'),
          value: null
        },
        {
          text: this.$t('components.review.rating_filter.negatives'),
          value: 1
        },
        {
          text: this.$t('components.review.rating_filter.neutral'),
          value: 2
        },
        {
          text: this.$t('components.review.rating_filter.positive'),
          value: 3
        }
      ],
      ratingOption: null
    }
  },
  methods: {
    handleRatingOption(e) {
      this.$emit('ratingOption', e)
    },
  }
}
</script>

<style scoped>

</style>